"use client";
import {
	redirect,
	usePathname,
	useSearchParams,
	RedirectType,
} from "next/navigation";
import posthog from "posthog-js";

import { makeUrl } from "~/shared/utils";

export const RedirectToLogin = () => {
	const pathname = usePathname();
	const searchParams = useSearchParams();

	const url = makeUrl("/login");

	if (pathname)
		url.searchParams.set(
			"referrer",
			searchParams ? `${pathname}?${searchParams}` : pathname
		);

	posthog.reset();

	redirect(url.pathname + url.search, RedirectType.replace);
};
